import { render, staticRenderFns } from "./Tenant.vue?vue&type=template&id=972252a8&scoped=true&"
import script from "./Tenant.vue?vue&type=script&lang=js&"
export * from "./Tenant.vue?vue&type=script&lang=js&"
import style0 from "./Tenant.vue?vue&type=style&index=0&id=972252a8&lang=sass&scoped=true&"
import style1 from "./Tenant.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972252a8",
  null
  
)

export default component.exports